import { LegalLayout } from '@/components/Legal/LegalLayout';
import { PRIVACY_INTRO, PRIVACY_SECTIONS, PRIVACY_EFFECTIVE_DATE } from '@/content/legalContent';

export function PrivacyPolicyPage() {
  return (
    <LegalLayout
      title="Privacy Policy"
      effectiveDate={PRIVACY_EFFECTIVE_DATE}
      intro={PRIVACY_INTRO}
      sections={PRIVACY_SECTIONS}
    />
  );
}
